import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../utils/TableCustomStyles";

function ApprovedDraftBooking() {
  const addform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  const [showNameError, setShowNameError] = useState(false);
  const [showCountryError, setShowCountryError] = useState(false);
  const [showHeadOfficeAddressLine1Error, setShowHeadOfficeAddressLine1Error] = useState(false);
  const [showHeadOfficeAddressLine2Error, setShowHeadOfficeAddressLine2Error] = useState(false);
  const [showCityError, setShowCityError] = useState(false);
  const [showPincodeError, setShowPincodeError] = useState(false);
  const [showStateError, setShowStateError] = useState(false);

  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateCountryError, setShowUpdateCountryError] = useState(false);
  const [showUpdateHeadOfficeAddressLine1Error, setShowUpdateHeadOfficeAddressLine1Error] = useState(false);
  const [showUpdateHeadOfficeAddressLine2Error, setShowUpdateHeadOfficeAddressLine2Error] = useState(false);
  const [showUpdateCityError, setShowUpdateCityError] = useState(false);
  const [showUpdatePincodeError, setShowUpdatePincodeError] = useState(false);
  const [showUpdateStateError, setShowUpdateStateError] = useState(false);

  const [updateId, setUpdateId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const [updateHeadOfficeAddressLine1, setUpdateHeadOfficeAddressLine1] = useState("");
  const [updateHeadOfficeAddressLine2, setUpdateHeadOfficeAddressLine2] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updatePincode, setUpdatePincode] = useState("");
  const [updateState, setUpdateState] = useState("");

  const getLoggenInUser = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
        if (response) {
            setLoggedInUser(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }
  
  const getCustomer = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/customer/');
        setTimeout(() => {
          if (response) {
              setData(response.data)
              setDataPending(false)
          }
        }, 500);
        
    } catch (err) {
        toast.error("Error in fetching customer data! Try again.");
    }
  }

  const getCountry = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/country/');
        const country_data = response.data
        const sorted_data = country_data.sort((a, b) => a.object_id - b.object_id)
        setCountryList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching country data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data?.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array?.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
  }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true)
    setRecordForDelete(data)
  }

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id)
    setUpdateName(row.name)
    setUpdateCountry(row.country)
    setUpdateHeadOfficeAddressLine1(row.head_office_address_line_1)
    setUpdateHeadOfficeAddressLine2(row.head_office_address_line_2)
    setUpdateCity(row.city)
    setUpdatePincode(row.pincode)
    setUpdateState(row.state)
  }

  useEffect(() => {
    getLoggenInUser()
    getCustomer()
    getCountry()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const columns = [
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Address',
      width: '800px',
      selector: row => row.head_office_address_line_1 + ", " + row.head_office_address_line_2 + ", " +
                        row.city + ", " + row.state + " - " + row.pincode,
      sortable: true,
    },
    {
      name: 'Country',
      center: true,
      selector: row => <div className="text-center">
          <img src={row.country_data?.image_url} height={20} width={35} style={{ marginBottom: 5 }}></img><br></br>
          <span>{row.country_data?.long_name}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("master:customer:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("master:customer:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/user/customer/'+id+'/');
        setShowDeleteModal(false)
        getCustomer()
        toast.success("Record deleted successfully")
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    getCustomer()
    setShowDeleteLoader(false)
  }

  const addNewCustomer = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)

    const data = {
      name: addform.current.name.value,
      country: addform.current.country.value,
      head_office_address_line_1: addform.current.head_office_address_line_1.value,
      head_office_address_line_2: addform.current.head_office_address_line_2.value,
      city: addform.current.city.value,
      pincode: addform.current.pincode.value,
      state: addform.current.state.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/customer/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 200 ) {
      toast.success("Customer Created Successfully")
    }
    getCustomer()
    setShowAddCanvas(false)
    setShowAddLoader(false)
  }

  const updateCustomer = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)

    const id = updateId

    const data = {
      name: updateName,
      country: updateCountry,
      head_office_address_line_1: updateHeadOfficeAddressLine1,
      head_office_address_line_2: updateHeadOfficeAddressLine2,
      city: updateCity,
      pincode: updatePincode,
      state: updateState,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/user/customer/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 200 ) {
      toast.success("Customer updated Successfully")
    }
    getCustomer()
    setShowUpdateCanvas(false)
    setShowUpdateLoader(false)
  }

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="DraftBooking" activeSubMenu="ApprovedDraftBooking" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Approved Draft Booking</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
            {
              currentUserRolePermissionData?.includes("master:customer:add")?
                <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection">
                  <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                  <span className="fw-bold">Add Customer</span>
                </Button>
              :
                ""
            }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedRecord(recordForDelete?.id)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Update Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowUpdateCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <form onSubmit={(e) => updateCustomer(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="name">Name: <i className="text-danger">*</i><span className="text-danger">{showUpdateNameError?"Name required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="name" name="name" placeholder="Enter Company Name"
                value={updateName} onChange={(e) => setUpdateName(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateNameError(true):setShowUpdateNameError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="country">Country: <i className="text-danger">*</i><span className="text-danger">{showUpdateCountryError?"Country required":""}</span></label>
                <select className="form-select form-select-sm" name="country" onChange={(e) => setUpdateCountry(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateCountryError(true):setShowUpdateCountryError(false)}>
                  <option value="" selected>Select Country</option>
                  {countryList.map(country => 
                    <option value={country.id} selected={updateCountry==country.id?true:false}>{country.long_name}</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="head_office_address_line_1">Head Office Address Line 1: <i className="text-danger">*</i><span className="text-danger">{showUpdateHeadOfficeAddressLine1Error?"Address required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="head_office_address_line_1" name="head_office_address_line_1" placeholder="Enter Address Line 1"
                value={updateHeadOfficeAddressLine1} onChange={(e) => setUpdateHeadOfficeAddressLine1(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateHeadOfficeAddressLine1Error(true):setShowUpdateHeadOfficeAddressLine1Error(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
              <label for="head_office_address_line_2">Head Office Address Line 2: <i className="text-danger">*</i><span className="text-danger">{showUpdateHeadOfficeAddressLine2Error?"Address required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="head_office_address_line_2" name="head_office_address_line_2" placeholder="Enter Address Line 2"
                value={updateHeadOfficeAddressLine2} onChange={(e) => setUpdateHeadOfficeAddressLine2(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateHeadOfficeAddressLine2Error(true):setShowUpdateHeadOfficeAddressLine2Error(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="city">City: <i className="text-danger">*</i><span className="text-danger">{showUpdateCityError?"City required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="city" name="city" placeholder="Enter City"
                value={updateCity} onChange={(e) => setUpdateCity(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateCityError(true):setShowUpdateCityError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="pincode">Pincode: <i className="text-danger">*</i><span className="text-danger">{showUpdatePincodeError?"Pincode required":""}</span></label>
                <input type="number" class="form-control form-control-sm" id="pincode" name="pincode" placeholder="Enter Pincode"
                value={updatePincode} onChange={(e) => setUpdatePincode(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdatePincodeError(true):setShowUpdatePincodeError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="state">State: <i className="text-danger">*</i><span className="text-danger">{showUpdateStateError?"State required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="state" name="state" placeholder="Enter State"
                value={updateState} onChange={(e) => setUpdateState(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateStateError(true):setShowUpdateStateError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => updateCustomer(e)}>
                  {showUpdateLoader?
                    <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                  :
                  <>
                    <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
                  </>
                  }
                  
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowAddCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
            <form ref={addform} onSubmit={(e) => addNewCustomer(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="full_name">Name: <i className="text-danger">*</i><span className="text-danger">{showNameError?" Name required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="name" name="name" placeholder="Enter Company Name"
                  onBlur={(e) => e.target.value==""?setShowNameError(true):setShowNameError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="country">Country: <i className="text-danger">*</i><span className="text-danger">{showCountryError?"Country required":""}</span></label>
                  <select className="form-select form-select-sm" name="country" onBlur={(e) => e.target.value==""?setShowCountryError(true):setShowCountryError(false)}>
                    <option value="" selected>Select Country</option>
                    {countryList.map(country => 
                      <option value={country.id}>{country.long_name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="head_office_address_line_1">Address Line 1: <i className="text-danger">*</i><span className="text-danger">{showHeadOfficeAddressLine1Error?"Address required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="head_office_address_line_1" name="head_office_address_line_1" placeholder="Enter Address Line 1"
                  onBlur={(e) => e.target.value==""?setShowHeadOfficeAddressLine1Error(true):setShowHeadOfficeAddressLine1Error(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="head_office_address_line_2">Address Line 2: <i className="text-danger">*</i><span className="text-danger">{showHeadOfficeAddressLine2Error?"Address required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="head_office_address_line_2" name="head_office_address_line_2" placeholder="Enter Address Line 2"
                  onBlur={(e) => e.target.value==""?setShowHeadOfficeAddressLine2Error(true):setShowHeadOfficeAddressLine2Error(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="city">City: <i className="text-danger">*</i><span className="text-danger">{showCityError?"City required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="city" name="city" placeholder="Enter City"
                  onBlur={(e) => e.target.value==""?setShowCityError(true):setShowCityError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="pincode">Pincode: <i className="text-danger">*</i><span className="text-danger">{showPincodeError?"Pincode required":""}</span></label>
                  <input type="number" class="form-control form-control-sm" id="pincode" name="pincode" placeholder="Enter Pincode"
                  onBlur={(e) => e.target.value==""?setShowPincodeError(true):setShowPincodeError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="state">State: <i className="text-danger">*</i><span className="text-danger">{showStateError?"State required":""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="state" name="state" placeholder="Enter State"
                  onBlur={(e) => e.target.value==""?setShowStateError(true):setShowStateError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => addNewCustomer(e)}>
                  {showAddLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                    </>
                  }
                  </Button>
                </div>
              </div>
            </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default ApprovedDraftBooking;
